import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { VerifierStaffAddPaymentMethodModalContent } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

export interface VerifierStaffAddPaymentMethodModalProps {
  returnRoute?: string;
}

export const VerifierStaffAddPaymentMethodModal: React.FC<
  VerifierStaffAddPaymentMethodModalProps
> = ({ returnRoute }) => {
  const { isMobile } = useScreenInfo();
  const { isOpen, closeModal, switchClosability } = useModal(ModalId.StripeAddPaymentMethodModal);

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={handleCloseModal}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [handleCloseModal]);

  const returnUrl = React.useMemo(() => {
    return window.location.origin + (returnRoute ?? '');
  }, [returnRoute]);

  return (
    <Modal
      title="Add payment method"
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{ open: isOpen, onClose: handleCloseModal, fullScreen: isMobile }}
      headerPadding="32px 32px 8px 32px"
    >
      <VerifierStaffAddPaymentMethodModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        returnUrl={returnUrl}
      />
    </Modal>
  );
};
